import { Component, Input } from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';

import { PlaybackOption } from './PlaybackOption';
import { SupportedPlaybacksService } from './SupportedPlaybacks.Service';
import { VbPlaybackManagerComponent } from './VbPlaybackManager.Component';

import { VbNestedMenuComponent } from './shared/VbNestedMenuComponent';

@Component({
	selector: 'vb-playback-menu-button',
	host: {
		class: 'submenuWrap menuButtonContainer'
	},
	template: `
		<div
			class="dropdown"
			dropdown
			#dropdown="bs-dropdown"
			placement="top right"
			[dropup]="true"
			[autoClose]="true"
			[hidden]="playbackManager.supportedPlaybackOptions.length <= 1">

			<ul
				class="dropdown-menu dropdownMenu playerSettingsMenu"
				*dropdownMenu
				#vbDropdownMenu
				aria-labelledby="buttonMenuPlaybackSource"
				id="dropdownPlaybackSourceMenu"
				role="menu"
				tabindex="0">
				<li role="none" class="menuHeading">
					<button type="button"
						role="menuitem"
						class="dropdown-item btn-link backToMainMenuItem"
						(click)="hideMenu()">
						<span>{{ translations.playbackSource }}</span>
					</button>
				</li>
				@for (playbackOption of playbackManager.supportedPlaybackOptions; track playbackOptionsTrackByFunc($index, playbackOption)) {
					<li role="none">
						<button type="button"
							role="menuitem"
							class="dropdown-item btn-link selectableItem"
							(click)="onMenuItemClick(playbackOption)">
							@if(isPlaybackSelected(playbackOption)) {
								<span class="glyphicons ok_2"></span>
							}
							{{ playbackOption.label }}
						</button>
					</li>
				}
			</ul>
		</div>`,
	standalone: false,
	styleUrls: ['./VbPlayerSettingsMenu.Component.ng.less', './MenuButton.ng.less']
})
export class VbPlaybackMenuButtonComponent extends VbNestedMenuComponent {
	@Input() public translations: any;
	@Input() public playbackManager: VbPlaybackManagerComponent;

	constructor(
		private supportedPlaybacks: SupportedPlaybacksService,
		private vgApi: VideogularComponent
	) {
		super();
	}

	public isPlaybackSelected(playbackOption: PlaybackOption): boolean {
		return this.vgApi.activeSource && this.vgApi.activeSource.label === playbackOption.label;
	}

	public onMenuItemClick(playbackOption: PlaybackOption): void {
		if (this.isPlaybackSelected(playbackOption)) {
			return;
		}

		this.playbackManager.onManualStreamSwitch.emit({
			src: playbackOption.src,
			isFlash: this.supportedPlaybacks.getIsFlashPlayback(playbackOption, this.vgApi.flashDisabled, this.vgApi),
			playback: playbackOption
		});

		this.playbackManager.updateSelection(playbackOption);
		this.hideMenu();
	}

	public playbackOptionsTrackByFunc(_index: number, playbackOption: PlaybackOption): string {
		return playbackOption.src;
	}
}
